import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGripVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 14,
	viewBox: "0 0 10 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3 0H1C0.4375 0 0 0.46875 0 1V3C0 3.5625 0.4375 4 1 4H3C3.53125 4 4 3.5625 4 3V1C4 0.46875 3.53125 0 3 0ZM3 5H1C0.4375 5 0 5.46875 0 6V8C0 8.5625 0.4375 9 1 9H3C3.53125 9 4 8.5625 4 8V6C4 5.46875 3.53125 5 3 5ZM3 10H1C0.4375 10 0 10.4688 0 11V13C0 13.5625 0.4375 14 1 14H3C3.53125 14 4 13.5625 4 13V11C4 10.4688 3.53125 10 3 10ZM9 0H7C6.4375 0 6 0.46875 6 1V3C6 3.5625 6.4375 4 7 4H9C9.53125 4 10 3.5625 10 3V1C10 0.46875 9.53125 0 9 0ZM9 5H7C6.4375 5 6 5.46875 6 6V8C6 8.5625 6.4375 9 7 9H9C9.53125 9 10 8.5625 10 8V6C10 5.46875 9.53125 5 9 5ZM9 10H7C6.4375 10 6 10.4688 6 11V13C6 13.5625 6.4375 14 7 14H9C9.53125 14 10 13.5625 10 13V11C10 10.4688 9.53125 10 9 10Z",
		fill: "#B0BEC5"
	})]
});
const ForwardRef = forwardRef(SvgGripVertical);
export { ForwardRef as ReactComponent };
